module.exports = __webpack_public_path__ + "880b568229ede72c57fcabfba3e36e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_SM_W_639px_H_660px.jpg
// module id = 398
// module chunks = 0